import apiClient from "../apiClient";

export interface VerifyTokenResponse {
	message: string;
	userId: number;
	firebaseUid: string;
	token: string;
	tokenType: string;
}

export enum AuthApi {
	Verify = "/auth/verify",
}

/**
 * 验证 Firebase ID Token
 * @param token Firebase 用户的 idToken
 * @returns 后端验证响应
 */
const verifyFirebaseToken = (token: string) =>
	apiClient.post<VerifyTokenResponse>({
		url: AuthApi.Verify,
		data: { token },
	});

export default {
	verifyFirebaseToken,
};
